import { Box, SwipeableDrawer } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Util from "../../Util";
import Close from "../../assets/Icon/close.png";
import Invalid from "../../assets/Icon/invalid.svg";
import ApiCalling from "../../network/ApiCalling";

const UserModal = (props) => {
  const show = props.show;
  const onClose = props.onClose;
  const userData = props.userData;
  const onSave = props.onSave;
  console.log(userData);
  const { t } = useTranslation();
  const getLanguage = Util.getSelectedLanguage();
  const [isStateUpdated, setIsStateUpdated] = useState(false);
  const [alertModal, setIsAlertModal] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (userData) {
      setEmail(userData.email);
    }
  }, [userData]);

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
    setEmailError("");
    setIsStateUpdated(true);
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
    setIsStateUpdated(true);
  };

  const handleSave = () => {
    setIsStateUpdated(false);
    setEmailError("");
    let error = false;
    if (email === "" || email === undefined) {
      setEmailError("Email is required");
      error = true;
    }
    if (!error) {
      const data = {
        id: userData?.id,
        email: email,
        password: password,
      };

      ApiCalling.apiCallBodyDataPost("user/update-user", data)
        .then((res) => {
          if (res.data.status) {
            onSave("success");
            setPassword("");
          }
        })
        .catch((err) => {
          console.log("err", err);
          onSave("error");
        })
        .finally(() => {});
    }
  };

  return (
    <div>
      <SwipeableDrawer
        anchor={getLanguage == "ar" ? "left" : "right"}
        open={show}
        onClose={() => {
          if (isStateUpdated) {
            setIsAlertModal(true);
          } else {
            onClose();
            // reset();
            setIsStateUpdated(false);
          }
        }}
        onOpen={() => {}}
      >
        <Box sx={{ width: "656px", padding: "20px" }} role="presentation">
          <div className="d-flex align-items-center justify-content-between">
            <div className="drawer-header">Update User Details</div>

            <button className="hidden-btn">
              <img
                src={Close}
                alt="Close"
                className="svg-icon"
                onClick={() => {
                  if (isStateUpdated) {
                    setIsAlertModal(true);
                  } else {
                    onClose();
                    //   reset();
                    setIsStateUpdated(false);
                  }
                }}
                height={20}
                width={20}
              />
            </button>
          </div>
          <hr style={{ backgroundColor: "#E5E7EB" }} />
          <div className="body mt-3">
            <div className="row mt-2">
              <div
                className="d-flex justify-content-between align-items-center mb-1"
                style={{ fontWeight: "bold", fontSize: "18px" }}
              >
                <div>Update User</div>
              </div>
              <div className="col-md-6 mt-4">
                <div className="input-filed">
                  <span className="basic-text required">{t("Email")}</span>
                  <input
                    className={`form-control ${
                      emailError.length > 0 ? "input-error" : "custom-input"
                    }`}
                    placeholder="User Email"
                    type="email"
                    onChange={handleChangeEmail}
                    value={email}
                  />
                  {emailError && (
                    <span className="invalid-error">
                      <img
                        className="fa fa-exclamation-circle mr-2 invalid-svg"
                        src={Invalid}
                      />
                      {emailError}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-6 mt-4">
                <div className="input-filed">
                  <span className="basic-text required">{t("Password")}</span>
                  <input
                    className={`form-control "custom-input"`}
                    placeholder="User Password"
                    type="password"
                    onChange={handleChangePassword}
                    value={password}
                  />
                </div>
              </div>
              <div
                className="border-top row"
                style={{
                  position: "fixed",
                  width: "656px",
                  bottom: "0px",
                  right: getLanguage !== "ar" && "0px",
                  background: "#ffffff",
                  padding: "10px",
                }}
              >
                <div className="col-md">
                  <button
                    style={{ float: "right" }}
                    className="primary-xl-btn btn"
                    onClick={handleSave}
                  >
                    {t("Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </SwipeableDrawer>
    </div>
  );
};

export default UserModal;
